export default ({ i18n }) => ({
  DUE_DATE_INFO: i18n.t`Assignment Modal - Due date info`
});
  


// WEBPACK FOOTER //
// ./components/current-assignment-modal/assign-list/assignment/components/due-date-info/translations.js